import { createGlobalStyle } from 'styled-components';
import {
  font,
  colors,
  gutter,
  border,
  delay,
  screen,
  link,
  zindex,
  initialBackground
} from '../styles/variables';
import KanitLightTtf from '../assets/fonts/Kanit/kanit-light/kanit-light.ttf';
import KanitLightEot from '../assets/fonts/Kanit/kanit-light/kanit-light.eot';
import KanitLightSvg from '../assets/fonts/Kanit/kanit-light/kanit-light.svg';

import KanitRegularTtf from '../assets/fonts/Kanit/kanit-regular/kanit-regular.ttf';
import KanitRegularEot from '../assets/fonts/Kanit/kanit-regular/kanit-regular.eot';
import KanitRegularSvg from '../assets/fonts/Kanit/kanit-regular/kanit-regular.svg';

import KanitMediumTtf from '../assets/fonts/Kanit/kanit-medium/kanit-medium.ttf';
import KanitMediumEot from '../assets/fonts/Kanit/kanit-medium/kanit-medium.eot';
import KanitMediumSvg from '../assets/fonts/Kanit/kanit-medium/kanit-medium.svg';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Kanit';
    src: url('${KanitLightEot}');
    src: url('${KanitLightEot}?#iefix') format('embedded-opentype'),
    url('${KanitLightTtf}') format('truetype'),
    url('${KanitLightSvg}#kanit-light') format('svg');
    font-weight: 300;
    font-style: normal;
  }
  
  @font-face {
    font-family: 'Kanit';
    src: url('${KanitRegularEot}');
    src: url('${KanitRegularEot}?#iefix') format('embedded-opentype'),
    url('${KanitRegularTtf}') format('truetype'),
    url('${KanitRegularSvg}#kanit-regular') format('svg');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Kanit';
    src: url('${KanitMediumEot}');
    src: url('${KanitMediumEot}?#iefix') format('embedded-opentype'),
    url('${KanitMediumTtf}') format('truetype'),
    url('${KanitMediumSvg}#kanit-medium') format('svg');
    font-weight: bold;
    font-style: normal;
  }
  *, ::after, ::before {
    box-sizing: border-box;
  }

  html {
    font-family: sans-serif;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }

  body{
    /* font-family: ${font.family}; */
    font-size: ${font.size.default};
    color: ${font.color.default};
    background-color: ${colors.background.default};
    font-weight: ${font.weight.normal};
    line-height: 1.43;
    margin: 0px;
    max-width: 100vw;
    overflow-x: hidden;
    background: ${initialBackground};
    &.lock{
      width: 100vw;
      height: 100vh;
      overflow: hidden;
    }
  }

  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  menu,
  nav,
  section,
  summary {
    display: block;
  }

  audio,
  canvas,
  progress,
  video {
    display: inline-block;
    vertical-align: baseline;
  }

  audio:not([controls]) {
    display: none;
    height: 0;
  }

  [hidden],
  template {
    display: none;
  }

  a{
    text-decoration: none;
    background-color: transparent;
    cursor: pointer;
    &:active,
    &:hover {
      outline: 0;
    }
  }

  abbr[title] {
    border-bottom: 1px dotted;
  }

  b,
  strong {
    font-weight: ${font.weight.bold};
  }

  dfn {
    font-style: italic;
  }

  small {
    font-size: 80%;
  }

  img {
    border: 0;
  }

  svg:not(:root) {
    overflow: hidden;
  }

  figure {
    margin: 1em 40px;
  }

  hr {
    box-sizing: content-box;
    height: 0;
    margin-block-start: ${gutter.default};
    margin-block-end: ${gutter.default};
  }

  pre {
    overflow: auto;
  }

  code,
  kbd,
  pre,
  samp {
    font-family: monospace, monospace;
    font-size: 1em;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    color: inherit;
    font: inherit;
    margin: 0;
  }

  button {
    overflow: visible;
    font-weight: ${font.weight.button};
  }

  button,
  select {
    text-transform: none;
  }

  button,
  html input[type="button"],
  input[type="reset"],
  input[type="submit"] {
    -webkit-appearance: button;
    cursor: pointer;
  }

  button[disabled],
  html input[disabled] {
    cursor: not-allowed;
  }

  button::-moz-focus-inner,
  input::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

  input {
    line-height: normal;
    outline: none;
  }

  input[type="checkbox"],
  input[type="radio"] {
    box-sizing: border-box;
    padding: 0;
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    height: auto;
    -webkit-appearance: none; 
    -moz-appearance:textfield;
    -ms-appearance: none; 
    -o-appearance: none; 
    margin: 0; 
  }


  input[type="search"] {
    -webkit-appearance: textfield;
    box-sizing: content-box;
  }

  input[type="search"]::-webkit-search-cancel-button,
  input[type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  fieldset {
    border: 1px solid #c0c0c0;
    margin: 0 2px;
    padding: 0.35em 0.625em 0.75em;
  }

  legend {
    border: 0;
    padding: 0;
  }

  textarea {
    overflow: auto;
  }

  optgroup {
    font-weight: ${font.weight.bold};
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  thead{
    display: table-header-group;
    vertical-align: middle;
    border-color: inherit;
  }
  
  td,
  th {
    padding: 0;
  }

  h1, h2, h3, h4, h5, h6{
    font-weight: ${font.weight.bold};
  }

  a{
    color: ${link.color};
    text-decoration: ${link.decoration};
  }

  .toast-top-left {
    top: 80px !important;
    left: 12px;
  }
  .toast-top-right {
    top: 80px !important;
    right: 12px;
  }

  .toast {
    background-color: #030303;
  }
  .toast-success {
    background-color: ${colors.success.default} !important;
  }
  .toast-error {
    background-color: ${colors.danger.default} !important;
  }
  .toast-info {
    background-color: ${colors.info.default} !important;
  }
  .toast-warning {
    background-color: ${colors.warning.default} !important;
  }

  #toast-container > div{
    box-shadow: none !important;
  }

  .swal2-container{
    z-index: 3172 !important;
  }

  .react-datepicker-wrapper{
    width: 100%;
  }

  .react-datepicker__day--keyboard-selected,
  .react-datepicker__month-text--keyboard-selected{
    background-color: ${colors.primary.default};
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range {
      border-radius: 0.3rem;
      background-color: ${colors.primary.default};
      color: #fff;
    }
    .react-datepicker__input-container{
      width: 100%;
      input{
        display: block;
        height: 48px;
        width: 100%;
        background-color: ${colors.background.input};
        border: ${border.default};
        border-radius: 0px;
        padding: ${gutter.small} ${gutter.default};
        transition: ${delay};
        &:focus{
          outline: none;
          box-shadow: 0 0 0 0.2rem rgba(156,4,5,.25);
        }
        ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
          color: ${font.color.light};
          opacity: 1; /* Firefox */
        }
    
        :-ms-input-placeholder { /* Internet Explorer 10-11 */
          color: ${font.color.light};
        }
    
        ::-ms-input-placeholder { /* Microsoft Edge */
          color: ${font.color.light};
        }
      }
    }

  .react-pdf__Document{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2480;
    background-color: rgba(0,0,0,0.2);
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    @media(max-width: ${screen.xs.max}){
      .react-pdf__Page__canvas{
        width: 100% !important;
        height: 100% !important;
      }
    }
  }

  /* Make clicks pass-through */
  #nprogress {
    pointer-events: none;
  }

  #nprogress .bar {
    background: #29d;

    position: fixed;
    z-index: ${zindex.modal};
    top: 0;
    left: 0;

    width: 100%;
    height: 2px;
  }

  /* Fancy blur effect */
  #nprogress .peg {
    display: block;
    position: absolute;
    right: 0px;
    width: 100px;
    height: 100%;
    box-shadow: 0 0 10px #29d, 0 0 5px #29d;
    opacity: 1;

    -webkit-transform: rotate(3deg) translate(0px, -4px);
    -ms-transform: rotate(3deg) translate(0px, -4px);
    transform: rotate(3deg) translate(0px, -4px);
  }

  /* Remove these to get rid of the spinner */
  #nprogress .spinner {
    display: block;
    position: fixed;
    z-index: ${zindex.modal};
    top: 15px;
    right: 15px;
  }

  #nprogress .spinner-icon {
    width: 18px;
    height: 18px;
    box-sizing: border-box;

    border: solid 2px transparent;
    border-top-color: ${colors.primary.default};
    border-left-color: ${colors.primary.default};
    border-radius: 50%;

    -webkit-animation: nprogress-spinner 400ms linear infinite;
    animation: nprogress-spinner 400ms linear infinite;
  }

  #nprogress .bar {
    height: 4px;
    background: ${colors.primary.default};
  }

  .nprogress-custom-parent {
    overflow: hidden;
    position: relative;
  }

  .nprogress-custom-parent #nprogress .spinner,
  .nprogress-custom-parent #nprogress .bar {
    position: absolute;
  }

  @-webkit-keyframes nprogress-spinner {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
  @keyframes nprogress-spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .swal2-container {
    backdrop-filter: blur(5px);
  }

  .swal2-popup {
    .swal2-title{
      font-size: ${font.size.title};
      /* font-weight: 300; */
    }
    .swal2-content{
      font-size: ${font.size.default};
      font-weight: 300;
    }
    .swal2-styled.swal2-confirm{
      background: ${colors.primary.default};
    }
    button {
      max-width: 250px;
      min-width: 250px;
    }
  }
`;


export default GlobalStyle;
